import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true // Use standalone: true for modern Angular (v14+)
})
export class MarkdownPipe implements PipeTransform {
  // Inject DomSanitizer to trust the generated HTML explicitly
  private sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';

    // Synchronously parse Markdown text into an HTML string
    const rawHtml = marked.parse(value) as string;

    // Sanitize and return safe HTML context for the browser
    return this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }
}
